import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

const AuthPromptDialog = ({ open, onClose, title, message }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const go = (path) => {
    navigate(path, {
      state: {
        from: location,
      },
    });
    onClose?.();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{title || "Sign in to continue"}</DialogTitle>

      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", lineHeight: 1.7 }}
          >
            {message ||
              "To view and contribute to this document in the Transcription Tool, please log in or create an account."}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="text">
          Not now
        </Button>
        <Button onClick={() => go("/signup")} variant="outlined">
          Sign up
        </Button>
        <Button onClick={() => go("/login")} variant="contained">
          Login
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AuthPromptDialog;
